import React, { useEffect, useContext, useState } from 'react';
import DashboardTabs from '../../shared/DashboardTabs'
import { AuthContext } from '../../../contexts/AuthContext';
import axios from 'axios';
import Util from '../../../Util'; 
import Breadcrumb from '../../shared/Breadcrumb';
import { apiRoutes } from '../../../AppSettings';
import alertify from 'alertifyjs';
import { Link } from 'react-router-dom';

const PatientProfile = (props) => {
    const patientId = props.location.state.patientId;
    const { userState } = useContext(AuthContext);
    const [patient, setPatient] = useState({});
    const [appoinments, setAppoinments] = useState([]); 
    const [top5Appoinments, setTop5Appoinments] = useState([]); 

    const updatePatient = (data) => {
        setPatient(data);
    };

    const updateAppoinments = (data) => {
        setAppoinments(data);
    };

    const updateTopAppoinments = (data) => {
        let sortedAppoinments = data.sort((a, b) => b.date - a.date)
        sortedAppoinments = sortedAppoinments.reverse();
        setTop5Appoinments(sortedAppoinments.slice(0,5));
    };

    useEffect(() => {
        const options = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'bearer '+ userState.token
            }
          };
        axios.get(apiRoutes.getPatient + patientId, options)
          .then((response) => {
                if(response.status === 200)
                {
                    const data = response.data;
                    updatePatient(data.data);
                }
            }, (error) => {
                console.log(error.response);
                alertify.error(Util.getErrorMessages(error.response.data.errorMessages));
            });

          axios.get(apiRoutes.getAppoinmentsByPatient + patientId, options)
          .then((response) => {
                if(response.status === 200)
                {
                    const data = response.data;
                    console.log(data);
                    updateAppoinments(data.data);
                    updateTopAppoinments(data.data);
                }
            }, (error) => {
                console.log(error.response);
                alertify.error(Util.getErrorMessages(error.response.data.errorMessages));
            });
    }, []);

    return ( 
        <div>
            <Breadcrumb title= "Patient Profiile"/>
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar dct-dashbd-lft">
                            <div className="card widget-profile pat-widget-profile">
                                <div className="card-body">
                                    <div className="pro-widget-content">
                                        <div className="profile-info-widget">
                                            <a href="#" className="booking-doc-img">
                                                <img src={Util.loadImage(patient.profileImage)} alt="User Image" />
                                            </a>
                                            <div className="profile-det-info">
                                                <h3>{patient.firstName} {patient.lastName}</h3>
                                                
                                                <div className="patient-details">
                                                    <h5><b>Patient ID :</b> {patient.patientNumber}</h5>
                                                    <h5 className="mb-0"><i className="fas fa-map-marker-alt"></i> {patient.state}, {patient.country}</h5>
                                                </div>
                                                <Link className="btn btn-white msg-btn" to={
                                                    {
                                                        pathname: `/chat`,
                                                        state: {
                                                            receiver: JSON.stringify(patient)
                                                        }
                                                    }
                                                }><i className="far fa-comment-alt"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="patient-info">
                                        <ul>
                                            <li>Phone <span>{patient.phone}</span></li>
                                            <li>Age <span>{ Util.getAge(new Date(patient.dob), new Date())}, {patient.gender}</span></li>
                                            <li>Blood Group <span>{patient.bloodGroup}</span></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header">
                                    <h4 className="card-title">Last Booking</h4>
                                </div>
                                <ul className="list-group list-group-flush">
                                    {
                                        top5Appoinments.map(a => (
                                            <li key={a.appoinmentId} className="list-group-item">
                                                <div className="media align-items-center">
                                                    <div className="mr-3">
                                                        <img alt="Image placeholder" src="assets/img/doctors/doctor-thumb-02.jpg" className="avatar  rounded-circle" />
                                                    </div>
                                                    <div className="media-body">
                                                        <h5 className="d-block mb-0">Dr. {a.doctor.firstName} {a.doctor.lastName} </h5>
                                                        <span className="d-block text-sm text-muted">{a.doctor.category}</span>
                                                        <span className="d-block text-sm text-muted">{Util.getFormatDate({date: a.appoinmentDate})}  {a.appoinmentTime}</span>
                                                    </div>
                                                </div>
                                            </li>
                                        ))
                                    }
                            </ul>
                            </div>
                        </div>
                        <div className="col-md-7 col-lg-8 col-xl-9 dct-appoinment">
                            <DashboardTabs PatientId = {patientId} userType={userState.userType} Details = {{Appoinments: appoinments}}  />
                        </div>
                    </div>
                </div>
            </div>		
        </div>
     );
}
 
export default PatientProfile;